/**
 * Flavors dropdown.
 *
 * The panel is a native <details>, so opening, closing, keyboard operation and
 * the expanded state announced to assistive tech all come from the element
 * itself and work with this file blocked. What is added here is only what
 * <details> does not do on its own:
 *
 *   - close on Escape, returning focus to the trigger,
 *   - close when a click lands outside the menu,
 *   - close when focus leaves the menu by tabbing,
 *   - keep only one menu open at a time.
 *
 * Hover is deliberately not an opener. A panel this size opening on passing
 * mouse movement is the classic mega-menu annoyance, and hover cannot be
 * reached by keyboard or touch anyway, so it would be a second, worse path to
 * the same thing.
 */

const menus = [...document.querySelectorAll('[data-mega]')];

if (menus.length) {
  const close = (menu, { restoreFocus = false } = {}) => {
    if (!menu.open) return;
    menu.open = false;
    if (restoreFocus) menu.querySelector('summary')?.focus();
  };

  const closeAll = (except) => menus.forEach((m) => m !== except && close(m));

  menus.forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (menu.open) closeAll(menu);
    });

    // Tabbing past the last item inside the panel should close it, the same way
    // clicking away does. Without this the panel stays open behind the rest of
    // the page while focus moves on.
    menu.addEventListener('focusout', (event) => {
      if (!menu.open) return;
      if (event.relatedTarget && !menu.contains(event.relatedTarget)) close(menu);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = menus.find((m) => m.open);
    if (open) {
      event.preventDefault();
      close(open, { restoreFocus: true });
    }
  });

  document.addEventListener('pointerdown', (event) => {
    const open = menus.find((m) => m.open);
    if (open && !open.contains(event.target)) close(open);
  });
}
